import {
  IFirmwareHistoryByProductResponseBody
} from 'rsc-iot-cloud-lib-sdk/petsafe/products/firmware/history-by-product';

export class FirmwareHistoryByProduct {
  public static sort(fh: IFirmwareHistoryByProductResponseBody): IFirmwareHistoryByProductResponseBody {
    return fh.sort((a, b) => {
      if (new Date(a.updatedAt).getTime() > new Date(b.updatedAt).getTime()) {
        return -1;
      }
      if (new Date(a.updatedAt).getTime() < new Date(b.updatedAt).getTime()) {
        return 1;
      }
      return 0;
    });
  }
}
